// @flow

import React from 'react';
import type { Node } from 'react';
import StyledRow from './row.styled';
import { Container, Flex } from '../grid';
import type { Props as StyledRowProps } from './row.styled';

type Props = {
  children: Node | Array<Node>,
} & StyledRowProps;

const Row = ({
  children,
  ...styledRowProps
}: Props) => (
  <StyledRow
    {...styledRowProps}
  >
    <Container>
      <Flex width={1} wrap>{children}</Flex>
    </Container>
  </StyledRow>
);

export default Row;
